import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaConfiguracionPagosTipocambioComponent {
  tipoCambio
  onClose
  reemplazar = false

  aceptar () {
    this.onClose({$event: {data: {tipoCambio: this.tipoCambio, reemplazar: this.reemplazar}}})
  }

  cerrar () {
    this.onClose({$event: {data: {}}})
  }
}

module.component('nominasNominaConfiguracionPagosTipocambio', {
  controller: NominasNominaConfiguracionPagosTipocambioComponent,
  template,
  bindings: {
    tipoCambio: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/configuracion/pagos/tipocambio/component.js